module.exports = __webpack_public_path__ + "img/04.0936fb59.png";